import { Grid, Typography, units } from '@hbf/dsl';
import { makeStyles } from 'tss-react/mui';
import { useIntl } from 'ha/i18n';
import React from 'react';
import { StudentResidenceNoticeTag } from '../StudentResidenceNoticeTag';

const useStyles = makeStyles()(() => ({
  container: {
    padding: units.rem(1),
    marginTop: units.rem(1),
    marginBottom: units.rem(1),
    backgroundColor: '#f9f9f9',
    color: '#2d4658',
  },
  tag: {
    marginLeft: units.rem(-1),
    marginTop: units.rem(-1),
    marginBottom: units.rem(1),
  },
}));

export interface Props {
  withTag?: boolean;
}

const StudentResidenceNoticeBanner: React.FC<Props> = ({ withTag = true }) => {
  const { classes } = useStyles();
  const { T } = useIntl();

  return (
    <Grid item>
      <div className={classes.container}>
        {withTag && (
          <div className={classes.tag}>
            <StudentResidenceNoticeTag />
          </div>
        )}
        <Typography.Paragraph>
          {T('student_accommodation.listing_page.banner_text')}
        </Typography.Paragraph>
      </div>
    </Grid>
  );
};

export { StudentResidenceNoticeBanner };
